import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import SearchableSelect from "../../../shared/Select/SearchableSelect";
import MultiSelect from "../../../shared/Select/MultiSelect";
import TextInput from "../../../shared/Input/TextInput";
import { UpdateDynamicAnswersAction } from "../../actions";

function DynamicFields() {
    const { taskDynamicFields, dynamicAnswers } = useSelector(state => state.createAppointment);
    const dispatch = useDispatch();

    const updateDynamicAnswers = (val, field) => {
        const existingField = dynamicAnswers.find((answer) => answer.field === field.name);
        let updatedDynamicAnswers = [];
        
        // Handle array values for multiple-dropdown
        const rawValues = Array.isArray(val) ? val : [val];
        
        // Convert values to labels for display in cs-dash
        let values = [];
        if (field.type === 'dropdown' || field.type === 'select' || field.type === 'multiple-dropdown') {
            rawValues.forEach(rawValue => {
                if (rawValue && field.options) {
                    const option = field.options.find(opt => opt.valueName === rawValue);
                    if (option) {
                        values.push(option.valueLabel);
                    }
                }
            });
        } else {
            values = rawValues;
        }
        
        if (existingField){
            dynamicAnswers.map(singleItem => {
				if (singleItem.field === existingField.field) {
					singleItem.values = values;
				}
				updatedDynamicAnswers.push(singleItem);
			});
            dispatch(UpdateDynamicAnswersAction(updatedDynamicAnswers));
        }
        else{
            const newField = {
                field: field.name,
                values: values,
                meta: field
			};
            dispatch(UpdateDynamicAnswersAction([
                ...dynamicAnswers,
                newField
            ]));
        }
    }

    const renderFieldItem = (field) => {
        if(field.type === 'dropdown' || field.type === 'select') {
            let dropdownValues = [];
            if (field.options && field.options.length){
                field.options.map((item) => {
                    const obj = {
                        value: item.valueName,
                        label: item.valueLabel
                    }
                    dropdownValues.push(obj);
                })
            }
            const singleField = dynamicAnswers.find((singleField) => singleField.field === field.name);
            
            // Convert stored label back to value for dropdown display
            let displayValue = null;
            if (singleField && singleField?.values?.length > 0 && field.options) {
                const option = field.options.find(opt => opt.valueLabel === singleField.values[0]);
                if (option) {
                    displayValue = option.valueName;
                }
            }
            
            return (
                <SearchableSelect
                    key={field.name}
                    label={field.label}
                    value={displayValue}
                    options={dropdownValues}
                    handleChange={val => updateDynamicAnswers(val, field)}
                    placeholder={field.placeholder || 'Select an option...'}
                />
            )
        } else if(field.type === 'multiple-dropdown') {
            let dropdownValues = [];
            if (field.options && field.options.length){
                field.options.map((item) => {
                    const obj = {
                        value: item.valueName,
                        label: item.valueLabel
                    }
                    dropdownValues.push(obj);
                })
            }
            const singleField = dynamicAnswers.find((singleField) => singleField.field === field.name);
            
            // Convert stored labels back to values for dropdown display
            let multiValue = [];
            if (singleField?.values && singleField.values.length > 0 && field.options) {
                multiValue = singleField.values.map(label => {
                    const option = field.options.find(opt => opt.valueLabel === label);
                    return option ? option.valueName : null;
                }).filter(val => val !== null);
            }
            
            return (
                <MultiSelect
                    key={field.name}
                    label={field.label}
                    value={multiValue}
                    options={dropdownValues}
                    handleChange={val => updateDynamicAnswers(val, field)}
                    placeholder={field.placeholder || 'Select options...'}
                />
            )
        } else if(field.type === 'text' || field.type === 'number') {
            const singleField = dynamicAnswers.find((singleField) => singleField.field === field.name);
            return (
                <TextInput
                    key={field.name}
                    value={(singleField && singleField?.values?.length > 0) ? singleField.values[0] : field.value || ''}
                    label={field.label}
                    placeholder={field.placeholder}
                    onBlur={e => updateDynamicAnswers(e.target.value, field)}
                />
            )
        } else {
            // Fallback for unknown field types - render as text input
            const singleField = dynamicAnswers.find((singleField) => singleField.field === field.name);
            return (
                <TextInput
                    key={field.name}
                    value={(singleField && singleField?.values?.length > 0) ? singleField.values[0] : field.value || ''}
                    label={field.label}
                    placeholder={field.placeholder}
                    onBlur={e => updateDynamicAnswers(e.target.value, field)}
                />
            )
        }
    }

    const renderFields = () => {
        if(taskDynamicFields && taskDynamicFields.fields && taskDynamicFields.fields.length) {
            return taskDynamicFields.fields.map(field => (
                <div className="my-2" key={field.name}>
                    {renderFieldItem(field)}
                </div>
            ));
        }
    }

    // console.log("DYNAMIC ANSWERS",dynamicAnswers);

    return (
        <div>
            {renderFields()}
        </div>
    )
}

export default DynamicFields;